<template>
  <rfq>
    <div class="cust-pa-wrap guest-quote-page">
      <pa-plan-select-page channel="customer" :guest="true" />
    </div>
  </rfq>
</template>

<script>
import Rfq from '@/components/layout/Rfq';
import PaPlanSelectPage from '@/components/pa/PaPlanSelectPage';

export default {
  name: 'GuestPaPlanSelect',
  components: { Rfq, PaPlanSelectPage },
  metaInfo: { title: 'Students PA — Get a quote' },
};
</script>

<style src="@/assets/css/customer-pa.css"></style>
<style scoped>
.guest-quote-page {
  padding-top: 8px;
  padding-bottom: 32px;
}
</style>
